<template>
  <div class="px-5 py-[44px]">
    <div ref="columnRoot" class="flex justify-start gap-5">
      <div
        v-for="column in content"
        :key="column._uid"
        class="flex w-32 flex-col"
      >
        <CMSLink
          v-if="column.titleLink"
          :cms-link="column.titleLink"
          class="mb-[10px] text-base font-bold leading-[19px]"
          @click="onClick($event, 2, column.Title)"
        >
          {{ column.Title }}
        </CMSLink>
        <span v-else class="mb-[10px] text-base font-bold leading-[19px]">
          {{ column.Title }}
        </span>
        <div class="flex flex-col">
          <CMSLink
            v-for="link in column.Links"
            :key="link._uid"
            :cms-link="transformLink(link)"
            class="whitespace-no-wrap hover:text-shadow inline-flex items-center gap-2 text-xs leading-5 tracking-wide transition duration-200 ease-linear"
            @click="onClick($event, 3, link.link_text)"
          >
            <span class="mb-[6px] text-sm font-normal leading-[19px]">
              {{ link.link_text }}
            </span>
          </CMSLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import useUiState from '~/composables/ui/useUiState'
import useTrackingEvents from '~/composables/tracking/useTrackingEvents'
import type {
  SbNavigationFlyoutContentColumn,
  SbNavigationFlyoutContentLink,
} from '~/cms/storyblok/types/storyblok'
import useRouteHelpers from '../../../composables/useRouteHelpers'

defineProps({
  content: {
    type: Array as PropType<SbNavigationFlyoutContentColumn[]>,
    required: true,
  },
})

const emit = defineEmits(['register-column'])
const { trackNavigationFlyout } = useTrackingEvents()
const { closeFlyoutMenu } = useUiState()
const { toLocalePath } = useRouteHelpers()
const columnRoot = ref(null)

const transformLink = (link: SbNavigationFlyoutContentLink) => {
  if (!link.Link) return {}

  return {
    ...link.Link,
    cached_url: getLink(link),
    linktype: link.Link.linktype || 'story',
  }
}

const getLink = (link: SbNavigationFlyoutContentLink) => {
  if (!link.Link?.cached_url) return ''

  // Handle external links
  if (link.Link.linktype === 'url') {
    return link.Link.cached_url
  }

  // Handle internal links
  const path = link.Link.cached_url.startsWith('/')
    ? link.Link.cached_url
    : '/' + link.Link.cached_url

  return toLocalePath(path).toString()
}

const onClick = (
  event: MouseEvent,
  navigationLevel: number,
  navigationPoint?: string,
) => {
  if (navigationPoint) {
    trackNavigationFlyout(navigationPoint, navigationLevel)
  }

  closeFlyoutMenu(event, true)
}

onMounted(() => {
  emit('register-column', columnRoot.value)
})
</script>
